/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceLevelUtilizationAggregate {
    getFixupPrototypeFunction() { return ResourceLevelUtilizationAggregate.fixupPrototype; }

    static newInstance(model: Partial<ResourceLevelUtilizationAggregate>): ResourceLevelUtilizationAggregate {
        let obj = Object.assign(new ResourceLevelUtilizationAggregate(), model);
        ResourceLevelUtilizationAggregate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceLevelUtilizationAggregate>): ResourceLevelUtilizationAggregate {
        if (!model) return null;
        return ResourceLevelUtilizationAggregate.newInstance(<ResourceLevelUtilizationAggregate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceLevelUtilizationAggregate) {
        if (!obj) return;

        models.ResourceLevelUtilizationAggregate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceLevelUtilizationAggregate): boolean {
        Object.setPrototypeOf(obj, ResourceLevelUtilizationAggregate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metric_data) {
            models.KpiMetricAggregate.fixupPrototype(this.metric_data);
        }
    }

    /**
     * Unique Id of the resource for which utilization detail is being shown.
     */
    resource_id: string;

    /**
     * Id of the service account to which the resource belongs to.
     */
    service_account_id: string;

    /**
     * Name of the os for the instance or vm.
     */
    platform: string;

    /**
     * Name of the resource for which utilization detail is being shown.
     */
    resource_name: string;

    metric_data: models.KpiMetricAggregate;

}
